import type { FeatureModule } from "../types";
import { IvrDesigner } from "./IvrDesigner";

export const ivrFeature: FeatureModule = {
  id: "ivr",
  path: "/scripts",
  label: "Scripts",
  nav: false,
  element: IvrDesigner,
};

export { IvrDesigner } from "./IvrDesigner";
